const BLOOD_ANALYSIS_TYPE = Object.freeze({
  ZACETNI: { id: "ZACETNI", translationKey: "bloodAnalysis.type.initial" },
  KONCNI: { id: "KONCNI", translationKey: "bloodAnalysis.type.final" },
});

export { BLOOD_ANALYSIS_TYPE };

export const BLOOD_ANALYSIS_TYPE_LIST = Object.freeze([
  BLOOD_ANALYSIS_TYPE.ZACETNI,
  BLOOD_ANALYSIS_TYPE.KONCNI,
]);

export const BLOOD_ANALYSIS_TYPES = {
  ZACETNI: "ZACETNI",
  KONCNI: "KONCNI",
};

export default BLOOD_ANALYSIS_TYPE;
